import ClassNames from "Helpers/Common";
import "./Button.css";

const VARIANT_STYLES = {
  Default: "bg-blue-chill text-white hover:bg-blue-light",
  Secondary: "bg-transparent text-blue-chill border border-blue-chill hover:bg-blue-chill/10",
  Delete: "bg-red-500 text-white hover:bg-red-600",
};

export const Button = ({ btnText, isDisabled = false, onClick, className, isLoading = false, children, id = 1, variant = "Default" }) => {
  return (
    <button
      type="button"
      key={id}
      disabled={isDisabled}
      onClick={() => onClick?.()}
      className={ClassNames(
        "flex justify-center items-center rounded-md text-sm font-normal focus:outline-none transition-colors",
        isDisabled
          ? "bg_alice_blue light_grayish_navy border border-gray-300 cursor-not-allowed opacity-60"
          : VARIANT_STYLES[variant] || VARIANT_STYLES.Default,
        className
      )}
    >
      {children}
      <div className="flex items-center justify-center gap-2 px-2">
        {isLoading ? (
          <div className="w-4 h-4 border-l-2 border-b-2 border-current rounded-full animate-spin" />
        ) : (
          btnText && <span>{btnText}</span>
        )}
      </div>
    </button>
  );
};
